export const unitsNames = {
  si: {
    id: 'si',
    name: 'SI',
    distance: 'km',
    precip: 'mm/h',
    precipAcc: 'cm',
    temperature: '°C',
    wind: 'm/s',
    pressure: 'hPa',
  },
  us: {
    id: 'us',
    name: 'US',
    distance: 'mi',
    precip: 'in/h',
    precipAcc: 'in',
    temperature: '°F',
    wind: 'mi/h',
    pressure: 'hPa',
  },
  uk2: {
    id: 'uk2',
    name: 'UK',
    distance: 'mi',
    precip: 'mm/h',
    precipAcc: 'cm',
    temperature: '°C',
    wind: 'mi/h',
    pressure: 'hPa',
  },
  ca: {
    id: 'ca',
    name: 'CA',
    distance: 'km',
    precip: 'mm/h',
    precipAcc: 'cm',
    temperature: '°C',
    wind: 'km/h',
    pressure: 'hPa',
  },
}